import React from 'react';
import ReactDOM from 'react-dom';
import charChoose from '../shared/CharChoose';

class NumChoose extends React.Component {
    render() {
        return (
            <div></div>
        );
    }
}

export default charChoose(NumChoose, 'num');


// WEBPACK FOOTER //
// ./src/components/sections/num/NumChoose.js